import DataList from './DataList';

export default DataList;
